import { ApolloProvider as UiKitApolloProvider } from "@apollo/client";
import React from "react";
import LoadingScreen from "../../components/LoadingScreen";
import useUserAuth from "../../hooks/useUserAuth";
import getApolloClient from "../../utils/getApolloClient";
import PermissionsProvider from "../PermissionsProvider";
import ThemeProvider from "../ThemeProvider";
export default function AppProvider({ children, uri, debug, name, loadingScreenVariant, ApolloProvider, }) {
    const { userId, userToken } = useUserAuth();
    if (userId && userToken) {
        const client = getApolloClient({
            token: userToken,
            uri,
            connectToDevTools: debug,
            name,
        });
        return (React.createElement(ApolloProvider, { client: client },
            React.createElement(UiKitApolloProvider, { client: client },
                React.createElement(PermissionsProvider, { userId: userId, debug: debug }, children))));
    }
    return (React.createElement(ThemeProvider, null,
        React.createElement(LoadingScreen, { variant: loadingScreenVariant })));
}
//# sourceMappingURL=index.js.map